import React from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  Box
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ClearIcon } from "@mui/x-date-pickers";
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";

const SearchComponent = ({
  searchTerm,
  onSearchChange,
  onClearSearch,
  placeholder = "Search...",
  width = { 
    xs: "100%",
    sm: "200px",
    md: "300px"
  },
  sx = {}
}) => {
  return (
    <Box sx={sx}>
      <TextField
        variant="outlined"
        placeholder={placeholder}
        value={typeof searchTerm === "string" ? searchTerm : ""}
        onChange={onSearchChange}
        sx={{
          maxWidth: width,
          width: width,
          "& .MuiOutlinedInput-root": {
            backgroundColor: MatxLayoutSettings.palette.white,
            color: MatxLayoutSettings.palette.mediumBlack,
            borderRadius: 2,
            padding: "20px",
            height: "32px",
            fontSize: "0.875rem",
            "& fieldset": {
              borderColor: MatxLayoutSettings.palette.active,
              borderWidth: "1px",
            },
            "&:hover fieldset": {
              borderColor: MatxLayoutSettings.palette.active,
            },
            "&.Mui-focused fieldset": {
              borderColor: MatxLayoutSettings.palette.active,
              borderWidth: "1px",
            },
          },
          "& .MuiInputBase-input": {
            padding: "8px 14px",
          },
        }}
        InputProps={{
          endAdornment: (
            <>
              {typeof searchTerm === "string" && searchTerm ? (
                <InputAdornment position="end">
                  <IconButton onClick={onClearSearch} edge="end" size="small">
                    <ClearIcon sx={{ fontSize: "14px" }} />
                  </IconButton>
                </InputAdornment>
              ) : (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              )}
            </>
          ),
        }}
      />
    </Box>
  );
};

export default SearchComponent;